const prosthetics = {
  hero: {
    titlePrefix: "Advanced",
    titleAccent: "Dental Prosthetics",
    titleSuffix: "Solutions",
    description:
      "Restore your smile and dental function with our custom-made, high-quality prosthetic solutions designed to look, feel, and perform like natural teeth.",
    ctas: {
      primary: "Book Consultation",
      secondary: "Learn About Process",
    },
    imageAlt: "Dental prosthetics including dentures and bridges",
    callout: {
      title: "Natural-Looking Results",
      body: "Our prosthetic solutions are crafted to match your natural teeth perfectly",
    },
  },
  benefits: {
    heading: "Benefits of Dental Prosthetics",
    intro: "Discover why patients choose our prosthetic solutions for smile restoration",
    items: [
      {
        title: "Natural Aesthetics",
        description:
          "Our prosthetics are designed to look indistinguishable from natural teeth, restoring your confident smile.",
      },
      {
        title: "Improved Function",
        description:
          "Enjoy eating, speaking, and smiling naturally again with properly fitted and functional prosthetic teeth.",
      },
      {
        title: "Better Oral Health",
        description:
          "Prosthetics help prevent shifting of remaining teeth and maintain facial structure and bone integrity.",
      },
      {
        title: "Long-lasting Results",
        description:
          "Our high-quality materials and expert craftsmanship ensure your prosthetics will provide years of service.",
      },
      {
        title: "Preventive Protection",
        description:
          "Dental prosthetics help protect your remaining natural teeth from excessive wear and stress.",
      },
      {
        title: "Customized Solutions",
        description:
          "Every prosthetic is custom-made to your specific needs, ensuring perfect fit and maximum comfort.",
      },
    ],
    bottomLinePrefix: "Ready to restore your smile?",
    bottomLineCta: "Schedule a prosthetic consultation today",
  },
  process: {
    heading: "Our Prosthetic Treatment Process",
    intro: "A step-by-step approach to restore your smile with precision and care",
    steps: [
      {
        title: "Initial Consultation",
        description:
          "Our specialist will evaluate your dental condition, discuss your needs, and explain available prosthetic options.",
      },
      {
        title: "Comprehensive Examination",
        description:
          "We'll conduct a thorough assessment including digital scans and X-rays to create a precise treatment plan.",
      },
      {
        title: "Treatment Planning",
        description:
          "Based on your examination, we'll develop a customized prosthetic solution tailored to your specific needs.",
      },
      {
        title: "Impressions & Design",
        description:
          "We take detailed impressions to ensure your prosthetics will fit perfectly and match your natural teeth.",
      },
      {
        title: "Fabrication & Fitting",
        description:
          "Your custom prosthetics are crafted in our laboratory and then precisely fitted for comfort and function.",
      },
      {
        title: "Follow-up & Maintenance",
        description:
          "We provide ongoing care instructions and schedule regular check-ups to ensure long-lasting results.",
      },
    ],
  },
  faq: {
    heading: "Frequently Asked Questions",
    intro: "Get answers to common questions about dental prosthetics",
    items: [
      {
        question: "What types of dental prosthetics do you offer?",
        answer:
          "We offer a comprehensive range of dental prosthetics including fixed prosthetics (crowns, bridges, and implant-supported restorations) and removable prosthetics (complete and partial dentures). Our specialists will help determine which option is best suited for your specific needs and preferences.",
      },
      {
        question: "How long do dental prosthetics last?",
        answer:
          "The lifespan of dental prosthetics varies depending on the type and materials used. With proper care and maintenance, crowns and bridges can last 10-15 years, while high-quality dentures typically last 5-7 years. Implant-supported prosthetics can last 15+ years or even a lifetime with excellent oral hygiene practices.",
      },
      {
        question: "Will my dental prosthetic look natural?",
        answer:
          "Absolutely! We pride ourselves on creating prosthetics that are virtually indistinguishable from natural teeth. Our advanced digital imaging technology and high-quality materials allow us to match the color, shape, and translucency of your natural teeth, ensuring a seamless and natural appearance.",
      },
      {
        question: "Is it difficult to adapt to wearing dental prosthetics?",
        answer:
          "There is typically an adjustment period when first receiving dental prosthetics. Most patients adapt within a few weeks as they become accustomed to speaking and eating with their new teeth. Our team provides comprehensive guidance and support throughout this transition period to ensure maximum comfort.",
      },
      {
        question: "How do I care for my dental prosthetics?",
        answer:
          "Care instructions vary depending on the type of prosthetic. Generally, fixed prosthetics require regular brushing, flossing, and professional cleanings. Removable prosthetics should be cleaned daily with specialized solutions and brushes, and stored properly when not in use. We provide detailed care instructions tailored to your specific prosthetic.",
      },
      {
        question: "Are dental prosthetics covered by insurance?",
        answer:
          "Many dental insurance plans provide partial coverage for prosthetic treatments, typically categorized as major restorative procedures. Coverage percentages vary by provider and plan. Our administrative team can help verify your insurance benefits and discuss financing options to make your treatment affordable.",
      },
    ],
    bottomLine: "Still have questions about our prosthetic solutions?",
    cta: "Contact Us",
  },
};

export default prosthetics;

